module.exports = __webpack_public_path__ + "static/media/ios-mail-unread.2175fd90.svg";